module.exports = __webpack_public_path__ + "static/sport/bgi-btn-i.69721d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-btn-i.png
// module id = YhpC
// module chunks = 0